/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PageProductPageResponse } from '../../models/page-product-page-response';

export interface GetProducts$Params {

/**
 * Filter on publication status of products
 */
  status: 'PUBLISHED' | 'DRAFT' | 'REJECTED' | 'ONGOING';

/**
 * Filter on brand
 */
  brand?: string;

/**
 * Filter on name
 */
  name?: string;

/**
 * Filter on ean
 */
  ean?: string;

/**
 * Filter on unit
 */
  unit?: 'MILLILITERS' | 'CENTILITERS' | 'DECILITERS' | 'LITERS' | 'GRAMS' | 'DECAGRAMS' | 'KILOGRAMS' | 'PIECES';

/**
 * Filter on amount
 */
  amount?: number;

/**
 * Filter on the packingMethodSubType of the standalone packaging unit. Or filter on the root.packingMethodSubType if its a collection packaging unit.
 */
  standalonePackingMethodSubType?: string;

/**
 * Filter based on existence of collectionPackaging
 */
  hasCollectionPackaging?: boolean;

/**
 * Zero-based page index (0..N)
 */
  page?: number;

/**
 * The size of the page to be returned
 */
  size?: number;

/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
  sort?: Array<string>;
}

export function getProducts(http: HttpClient, rootUrl: string, params: GetProducts$Params, context?: HttpContext): Observable<StrictHttpResponse<PageProductPageResponse>> {
  const rb = new RequestBuilder(rootUrl, getProducts.PATH, 'get');
  if (params) {
    rb.query('status', params.status, {});
    rb.query('brand', params.brand, {});
    rb.query('name', params.name, {});
    rb.query('ean', params.ean, {});
    rb.query('unit', params.unit, {});
    rb.query('amount', params.amount, {});
    rb.query('standalonePackingMethodSubType', params.standalonePackingMethodSubType, {});
    rb.query('hasCollectionPackaging', params.hasCollectionPackaging, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('sort', params.sort, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PageProductPageResponse>;
    })
  );
}

getProducts.PATH = '/products';
